// extracted by mini-css-extract-plugin
export var fadeInAnimation = "MandatoryFootnote-module--fadeInAnimation--74166";
export var mandatoryNote = "MandatoryFootnote-module--mandatoryNote--fd943";
export var mandatorySymbol = "MandatoryFootnote-module--mandatorySymbol--82626";